import { setAlertFunc } from "components/AlertToaster/AlertSlice"
import { api } from "../../api"
import {
    ChargerStationPayload,
    HistoryResponse,
    IOtherDetailItem,
    IResponse,
    StatusButton,
    TicketDataResponseType,
} from "../Common/commonTypes"

type Contacts = {
    country_code: string
    email: string
    id: number
    mapping_id: number
    name: string
    phone: string
}[]

export type HostDetail = {
    account_holder_name: string
    account_number: string
    account_type: string
    addr_id: number | null
    address: string
    bank_detail_id: number
    bank_name: string
    city: string
    city_id: number
    contacts: Contacts
    country: string
    country_id: number
    host_rent: string
    rent_esc: number
    rent_esc_amt: string
    rent_esc_duration: number
    gstin_addr: string
    gstin_file_url: string | null
    agreement_doc?: string | null
    host_name: string
    host_status: string
    ifsc_code: string
    latitude: number
    legal_business_name: string
    longitude: number
    pan: string | null
    pincode: string
    state: string
    state_id: number
    chargers: HostCharger[]
}
export type CpoDetail = {
    account_holder_name: string
    account_number: string
    account_type: string | null
    addr_id: number | null
    address: string
    bank_detail_id: number
    bank_name: string
    city: string
    city_id: number
    contacts: Contacts
    country: string
    country_id: number
    cpo_name: string
    cpo_status: string
    cpo_type: string | null
    deal_amount: string
    deal_amount_esc: number
    gstin: string
    ifsc_code: string
    invoice_required: number
    is_franchise: number
    legal_business_name: string
    license_fee_ac: string
    license_fee_dc: string
    pan: string | null
    pincode: string
    state: string
    state_id: number
    gstin_addr?: string
    gstin_file_url?: string
    file_url?: string | null
}
export type FranchiseDetail = {
    account_holder_name: string
    account_number: string
    account_type: string | null
    addr_id: number | null
    address: string
    bank_detail_id: number
    bank_name: string
    city: string
    city_id: number
    contacts: Contacts
    country: string
    country_id: number
    franchise_name: string
    franchise_legal_name: string
    franchise_status: string
    is_saas_fee_applicable: 0 | 1 | null
    saas_fee_ac: string | null
    saas_fee_dc: string | null
    franchise_host: 0 | 1 | null
    tenure: number | null
    agreement_start_date: string | null
    agreement_end_date: string | null
    agreement_url: string | null
    gstin: string
    ifsc_code: string
    pan: string | null
    pincode: string
    state: string
    state_id: number
    gstin_addr?: string
    gstin_file_url?: string
}
export type Address = {
    id: number
    address: string
    address_type: string
    area: string | null
    city: string
    city_id: number
    country_id: number
    gstin: string
    is_primary: number
    landmark: string | null
    latitude: number | null
    longitude: number | null
    location_subtype: string | null
    location_type: string | null
    pincode: string
    state: string
    state_id: number
    street: string | null
}

export type AddressResponse = {
    data: Address[]
}

export type ContactResponse = {
    data: {
        id: number
        name: string
        email: string
        phone: string
        country_code: string
    }[]
}
export type HostCharger = {
    charger_id: number
    charger_name: string
    deal_terms: string
    host_profit: string
    host_profit_amt: string | null
    host_profit_type: string | null
    host_rent: string
    item_description: string
    operational_power_rating: number
    sku: string
}
export type HostFormDetails = {
    addr_id: number
    address: string
    city: string
    city_id: number
    country: string
    country_id: number
    state: string
    state_id: number
    pincode: string
    gstin: string
    host_name: string
    legal_business_name: string
    gstin_addr?: string
    host_rent: string
    rent_esc: number
    rent_esc_amt: string
    rent_esc_duration: number
    file_url: string
    contacts: Contacts
}
export type HostFormDetailsResponse = {
    chargers: HostCharger[]
    host_details: HostFormDetails
}

export type SiteFormDetailsResponse = {
    id: number
    site_id: string
    site_name: string
    address: string
    landmark: string
    city: string
    city_id: number
    state: string
    state_id: number
    country: string
    country_id: number
    pincode: string
    latitude: number
    longitude: number

    access_type: string
    location_type: string
    location_subtype: string

    is_cobranded: number
    cobrand_id: number
    cobranded: string

    amenities: number[]

    parking_slots: number
    parking_type: string
    parking_type_dropdown: string[]

    vehicle_movement: string[]
    vehicle_type_dropdown: string[]

    open_time: string
    close_time: string
    is_open_24_hours: number
}
export type ConnectorDetail = {
    id: number
    connector_type: string
    display_name: string
    power_rating: number
}
export type ChargerDetail = {
    charger_id: number
    plp_id: number
    charger_name: string
    charger_type: string
    cin: string | null
    connector_details: ConnectorDetail[]
    installation_sequence: number | null
    item_description: string
    ocpp_id_1: string
    ocpp_id_2: string
    ocpp_id_3: string
    operational_power_rating: number
    operational_status: string
    price: string
    sku: string
    text_color_code: string | null
}
export type ChargerFormDetailsResponse = {
    address: string
    city: string
    city_id: number
    state: string
    state_id: number
    country: string
    country_id: number
    pincode: string
    site_id: string
    site_name: string
    cpo: string
    chargers: ChargerDetail[]
}
const buildOnboardingParams = (params: any, showDealType: boolean) => ({
    tags: params.data.tags ?? "",
    status: params.data.statusId ?? "",
    executed_by: params.data.assigned_to?.id ?? "",
    csms_partner: params.data.csms_partner_name?.id ?? "",
    cpo_id: params.data.cpo_account_name ?? "",
    on_hold: params.data.on_hold?.id ?? "",
    age: JSON.stringify(params.data.age ?? []),
    age_op: params.data.age_op?.id ?? "",
    ticket_to: params.data.TicketEndDate ?? "",
    ticket_from: params.data.TicketStartDate ?? "",
    read_filter: params.data.ReadUnread ?? "all",
    name: params.data.search_key ?? "",
    page_size: params?.selectedValue,
    page: params?.page,
    ...(params.data?.site_id?.length ? { site_id: params.data.site_id.join(",") } : {}),
    // Comma separated, not a JSON array — this module's endpoints want category_ids=2,3,6. Sent
    // only when something is selected, so an unfiltered list carries no category param at all.
    ...(params.data?.category_ids?.length
        ? {
              category_ids: params.data.category_ids
                  .map((i: any) => (typeof i === "object" ? i.id : i))
                  .join(","),
          }
        : {}),
    ...(showDealType ? { deal_type: params.data.dealType ?? "" } : {}),
    ...(params?.downloadData ? { download: params?.downloadData ? 1 : 0 } : {}),
})

export type EntityMappingStatusEntity = {
    exists: boolean
    id: number
    name: string
    contact_id?: number | null
    type?: string
}

export type PushCSMSLogStatusItem = {
    csms_id?: number
    status: string
}

export type PushCSMSLogStatus = {
    host?: PushCSMSLogStatusItem
    cpo?: PushCSMSLogStatusItem
    station?: PushCSMSLogStatusItem
    chargers?: { [chargerKey: string]: PushCSMSLogStatusItem }
}

export type PushCSMSLog = {
    id: string
    created_at: string
    error: string | null
    status: PushCSMSLogStatus
    task_status: string
    user_id: number
    user_name: string
}

export type EntityMappingStatus = {
    cpo: EntityMappingStatusEntity
    host: EntityMappingStatusEntity
    station: EntityMappingStatusEntity
    chargers: EntityMappingStatusEntity[]
}

type OnboardingRelatedTickets = {
    project_id: number
    ticket_id: number
    tickets: IOtherDetailItem[]
    total: number
}

const MODULE_URL = `onboarding/stations`
const MODULE_URL_2 = `onboarding`

const OnboardingService = api.injectEndpoints({
    endpoints: build => ({
        getOnboardingTabs: build.query({
            query: params => ({
                url: `${MODULE_URL}/deal_type_metrics`,
                params: buildOnboardingParams(params, false),
            }),
            providesTags: ["Onboarding"],
        }),
        getOnboardingData: build.query<
            TicketDataResponseType,
            { data: any; selectedValue: number; page: number; downloadData?: boolean }
        >({
            query: params => ({
                url: `${MODULE_URL}/onboarding_list`,
                params: buildOnboardingParams(params, true),
            }),
            providesTags: ["Onboarding"],
        }),

        getOnboardingMetrics: build.query<IResponse<any>, { data: any; selectedValue: number; page: number }>({
            query: params => ({
                url: `${MODULE_URL}/onboarding_ticket_counts`,
                params: buildOnboardingParams(params, true),
            }),
            // providesTags: ["Onboarding"],
        }),
        getOnHold: build.query<any, void>({
            query: () => ({
                url: `on_hold_teams`,
            }),
        }),
        getCoBranded: build.query<any, void>({
            query: () => ({
                url: `cobranded_companies`,
                useV3: true,
            }),
        }),
        getDealTerms: build.query<{ data: { id: string; name: string }[] }, void>({
            query: () => ({
                url: `deal_terms`,
                useV3: true,
            }),
        }),
        getContacts: build.query<
            ContactResponse,
            { name: string; ref_id: number; contact_type: string; user_id?: number; module_id?: number; ctype_mod?: string }
        >({
            query: ({ name, contact_type, ref_id, module_id, ctype_mod }) => ({
                url: `contacts`,
                useV3: true,
                params: {
                    name,
                    ref_id,
                    contact_type,
                    module_id,
                    ctype_mod,
                },
            }),
            providesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.ref_id }],
        }),
        getBillingAddress: build.query<AddressResponse, { reference_type: string; reference_id: number }>({
            query: ({ reference_id, reference_type }) => ({
                url: `addresses`,
                useV3: true,
                params: {
                    reference_type,
                    reference_id,
                },
            }),
            providesTags: (result, error, arg) => [{ type: "Onboarding", id: `BillingAddress` }],
        }),
        getSiteDetail: build.query<SiteFormDetailsResponse, { site_id: string }>({
            query: ({ site_id }) => ({
                url: `${MODULE_URL_2}/site_form_details`,
                useV3: true,
                params: {
                    site_id,
                },
            }),
            providesTags: (result, error, arg) => [{ type: "Onboarding", id: "siteDetail" }],
        }),
        getHostDetail: build.query<HostFormDetailsResponse, { site_id: number; project_id: number; host_id: number }>({
            query: ({ site_id, project_id, host_id }) => ({
                url: `${MODULE_URL_2}/host_form_details`,
                useV3: true,
                params: {
                    site_id,
                    host_id,
                    project_id,
                },
            }),
            providesTags: (result, error, arg) => [{ type: "Onboarding", id: "HostDetail" }],
        }),

        getChargerForm: build.query<ChargerFormDetailsResponse, { site_id: number; project_id: number }>({
            query: ({ site_id, project_id }) => ({
                url: `${MODULE_URL_2}/charger_form_details`,
                useV3: true,
                params: {
                    site_id,
                    project_id,
                },
            }),
        }),
        getOnboardingTicketDetails: build.query<ChargerStationPayload, { ticket_id: string }>({
            query: ({ ticket_id }) => ({
                url: `${MODULE_URL_2}/site/details`,
                useV3: true,
                params: {
                    ticket_id,
                },
            }),
            providesTags: ["Onboarding"],
        }),

        getOnboardingCPOTicketDetails: build.query<CpoDetail, { cpo_id: number; project_id: number }>({
            query: ({ cpo_id, project_id }) => ({
                url: `${MODULE_URL_2}/cpo/details`,
                useV3: true,
                params: {
                    cpo_id,
                    project_id,
                },
            }),
            providesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.cpo_id }],
        }),
        getOnboardingHostTicketDetails: build.query<HostDetail, { host_id: number; project_id: number }>({
            query: ({ host_id, project_id }) => ({
                url: `${MODULE_URL_2}/host/details`,
                useV3: true,
                params: {
                    host_id,
                    project_id,
                },
            }),
            providesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.host_id }],
        }),
        getOnboardingFranchiseTicketDetails: build.query<FranchiseDetail, { onb_id: number; franchise_id: number }>({
            query: ({ onb_id, franchise_id }) => ({
                url: `${MODULE_URL_2}/franchise_deatils`,
                useV3: true,
                params: {
                    onb_id,
                    franchise_id,
                },
            }),
            transformResponse: (response: any): FranchiseDetail => ({
                ...response,
                franchise_name: response?.name ?? null,
                franchise_legal_name: response?.legal_name ?? null,
                saas_fee_ac: response?.saas_ac ?? null,
                saas_fee_dc: response?.saas_dc ?? null,
                franchise_host: response?.host_managed_by ?? null,
                agreement_start_date: response?.agreement_start ?? null,
                agreement_end_date: response?.agreement_end ?? null,
                agreement_url: response?.franchise_agreement ?? null,
                is_saas_fee_applicable:
                    response?.saas_fee_applicable ?? (response?.saas_ac != null || response?.saas_dc != null ? 1 : 0),
            }),
            providesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.franchise_id }],
        }),
        getOnboardingTicketHistory: build.query<HistoryResponse, { ticket_id: string }>({
            query: ({ ticket_id }) => ({
                url: `${MODULE_URL_2}/history`,
                useV3: true,
                params: {
                    ticket_id,
                },
            }),
            providesTags: (result, error, args) => [{ type: "Onboarding", id: args.ticket_id }],
        }),
        getOnboardingRelatedTickets: build.query<OnboardingRelatedTickets[], { project_id: number }>({
            query: ({ project_id }) => ({
                url: `${MODULE_URL_2}/related_tickets`,
                useV3: true,
                params: { project_id },
            }),
            transformResponse: (response: OnboardingRelatedTickets | OnboardingRelatedTickets[]) =>
                Array.isArray(response) ? response : [response],
        }),
        getOnboardingButtonDropdown: build.query<IResponse<StatusButton[]>, { ticket_id: string }>({
            query: ({ ticket_id }) => ({
                url: `${MODULE_URL_2}/button_actions`,
                useV3: true,
                params: {
                    ticket_id,
                },
            }),
            providesTags: (result, error, args) => [{ type: "Onboarding", id: `Button${args.ticket_id}` }],
        }),

        getOnboardingSkipStatuses: build.query<IResponse<{ id: number; name: string }>, { search_key: string } | void>({
            query: params => ({
                url: `${MODULE_URL}/statuses`,
                params: {
                    search_key: params?.search_key ?? "",
                },
            }),
            providesTags: ["Onboarding"],
        }),
        editStationDetail: build.mutation({
            query: body => ({
                url: `${MODULE_URL_2}/site/update`,
                method: "PUT",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: ["Onboarding"],
        }),
        editHostDetail: build.mutation({
            query: body => ({
                url: `${MODULE_URL_2}/host_form_update`,
                method: "PUT",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: "HostDetail" }],
        }),
        editHostCharger: build.mutation({
            query: body => ({
                url: `${MODULE_URL_2}/host_deals_update`,
                method: "PUT",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.host_id }],
        }),
        editTicketStatus: build.mutation({
            query: body => ({
                url: `${MODULE_URL_2}/onboarding_actions`,
                method: "POST",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: ["Onboarding"],
        }),
        editChargerDetail: build.mutation({
            query: body => ({
                url: `sites/update_charger_details`,
                method: "PUT",
                body: body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
        }),
        pushToCSMS: build.mutation({
            query: body => ({
                url: `${MODULE_URL_2}/push_to_csms`,
                method: "POST",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    const errorData = error?.error?.data
                    let errorMsg = "Push to CSMS failed"
                    if (Array.isArray(errorData) && errorData.length > 0) {
                        errorMsg = errorData
                            .map((e: any) => (e.loc?.length ? `${e.loc.join(".")}: ${e.msg}` : e.msg))
                            .join("; ")
                    } else if (errorData?.error) {
                        errorMsg = errorData.error
                    }
                    dispatch(setAlertFunc({ type: "error", msg: errorMsg }))
                }
            },
            invalidatesTags: ["Onboarding"],
        }),
        editHoldStatus: build.mutation({
            query: body => ({
                url: `ticket_on_hold`,
                method: "POST",
                body,
                useV3: true,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    const error_text =
                        error?.error?.data?.error ||
                        error?.error?.data?.message ||
                        error?.message ||
                        error?.error ||
                        "Something went wrong!"
                    dispatch(setAlertFunc({ type: "error", msg: error_text }))
                }
            },
            invalidatesTags: ["Onboarding", "Survey", "Approvals"],
        }),
        editDropStatus: build.mutation({
            query: body => ({
                url: `${MODULE_URL}/drop_onb_ticket`,
                method: "POST",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.msg }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.msg }))
                }
            },
            invalidatesTags: ["Onboarding"],
        }),

        updateInstallationSequence: build.mutation<
            { message: string },
            { user_id: number; updates: { plp_id: number; installation_sequence: number }[] }
        >({
            query: body => ({
                url: `${MODULE_URL_2}/update_installation_sequence`,
                method: "PUT",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(
                        setAlertFunc({
                            type: "error",
                            msg: error?.error?.data?.error || error?.message || "Failed to update sequence",
                        })
                    )
                }
            },
            invalidatesTags: ["Onboarding"],
        }),
        editAuthFile: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `accounts/update_cpo_auth_sign`,
                method: "PUT",
                body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.get("cpo_id") as string }],
        }),
        editHostAgreementFile: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `${MODULE_URL_2}/update_host_agreement`,
                method: "PUT",
                useV3: true,
                body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
        }),
        editFranchiseAgreementFile: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `${MODULE_URL_2}/update_franchise_agreement`,
                method: "PUT",
                useV3: true,
                body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [
                { type: "Onboarding", id: arg.get("ticket_id") as string },
                "Projects",
            ],
        }),
        editDirectionReach: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `${MODULE_URL_2}/site/directions`,
                method: "PUT",
                useV3: true,
                body: body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: ["Onboarding", "Sites"],
        }),
        editCPORevenue: build.mutation({
            query: body => ({
                url: `${MODULE_URL_2}/cpo/account_deals`,
                method: "PUT",
                body: body,
                useV3: true,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.account_id }],
        }),
        editReadUnreadStatus: build.mutation({
            query: body => ({
                url: `${MODULE_URL}/onb_read_ticket`,
                method: "POST",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.msg }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
        }),
        addBillingAddress: build.mutation({
            query: body => ({
                url: `update_atpm_addr`,
                method: "PUT",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: `BillingAddress` }],
        }),
        editCPOForm: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `accounts/edit_cpo`,
                method: "PUT",
                body: body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.get("cpo_id") as string }],
        }),
        editFranchiseForm: build.mutation<{ message: string }, FormData>({
            query: body => ({
                url: `accounts/edit_franchise`,
                method: "PUT",
                body: body,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.get("franchise_id") as string }],
        }),
        editFranchiseDealDetails: build.mutation<
            { message: string },
            {
                franchise_id: number
                project_id: number
                site_id: number
                user_id: number
                ticket_id?: number
                contacts: string | null
                billing_address: number | null
                is_saas_fee_applicable: 0 | 1
                saas_fee_ac: number | null
                saas_fee_dc: number | null
                franchise_host: 0 | 1 | null
                tenure: number | null
                agreement_start_date: string | null
                agreement_end_date: string | null
            }
        >({
            query: body => ({
                url: `${MODULE_URL_2}/franchise/account_deals`,
                method: "PUT",
                body: body,
                useV3: true,
            }),
            onQueryStarted: async (arg, { dispatch, queryFulfilled }) => {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error?.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: arg.franchise_id }, "Projects"],
        }),
        editStationForm: build.mutation({
            query: body => ({
                url: `sites/update_site`,
                method: "PUT",
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => [{ type: "Onboarding", id: "siteDetail" }],
        }),
        getEntityMappingStatus: build.query<EntityMappingStatus, { ticket_id: number }>({
            query: ({ ticket_id }) => ({
                url: `${MODULE_URL_2}/entity_mapping_status`,
                useV3: true,
                params: { ticket_id },
            }),
        }),
        getPushCSMSLogs: build.query<PushCSMSLog[], { ticket_id: number; module_id: number }>({
            query: ({ ticket_id, module_id }) => ({
                url: `${MODULE_URL_2}/push_csms_logs`,
                useV3: true,
                params: { ticket_id, module_id },
            }),
        }),
        getPushCSMSLogPayload: build.query<any, { doc_id: string; entity: string; ocpp_id?: string }>({
            query: ({ doc_id, entity, ocpp_id }) => ({
                url: `${MODULE_URL_2}/push_csms_log_payload`,
                useV3: true,
                params: {
                    doc_id,
                    entity,
                    ...(ocpp_id ? { ocpp_id } : {}),
                },
            }),
        }),
        addContactsMapping: build.mutation({
            query: body => ({
                url: `${MODULE_URL_2}/add_ecm_mapping`,
                method: "POST",
                useV3: true,
                body,
            }),
            async onQueryStarted(arg, { dispatch, queryFulfilled }) {
                try {
                    const { data } = await queryFulfilled
                    dispatch(setAlertFunc({ type: "success", msg: data?.message }))
                } catch (error: any) {
                    dispatch(setAlertFunc({ type: "error", msg: error.message }))
                }
            },
            invalidatesTags: (result, error, arg) => {
                const tags: { type: "Onboarding"; id: number | string }[] = []

                if (arg.host_id) {
                    tags.push({ type: "Onboarding", id: arg.host_id })
                }
                if (arg.cpo_id) {
                    tags.push({ type: "Onboarding", id: arg.cpo_id })
                }
                if (arg.franchise_id) {
                    tags.push({ type: "Onboarding", id: arg.franchise_id })
                }

                return tags
            },
        }),
    }),
})

export const {
    useLazyGetOnboardingTabsQuery,
    useLazyGetOnboardingDataQuery,
    useLazyGetOnboardingMetricsQuery,
    useGetOnboardingButtonDropdownQuery,
    useGetOnHoldQuery,
    useGetCoBrandedQuery,
    useGetSiteDetailQuery,
    useGetHostDetailQuery,
    useGetDealTermsQuery,
    useGetChargerFormQuery,
    useGetOnboardingHostTicketDetailsQuery,
    useGetOnboardingTicketDetailsQuery,
    useGetOnboardingCPOTicketDetailsQuery,
    useGetOnboardingFranchiseTicketDetailsQuery,
    useGetOnboardingTicketHistoryQuery,
    useGetOnboardingRelatedTicketsQuery,
    useLazyGetOnboardingSkipStatusesQuery,
    useEditHoldStatusMutation,
    useEditDropStatusMutation,
    useEditStationDetailMutation,
    useEditAuthFileMutation,
    useEditReadUnreadStatusMutation,
    useEditCPORevenueMutation,
    useEditChargerDetailMutation,
    useEditDirectionReachMutation,
    useGetBillingAddressQuery,
    useGetContactsQuery,
    useEditCPOFormMutation,
    useEditFranchiseFormMutation,
    useEditFranchiseDealDetailsMutation,
    useEditStationFormMutation,
    useEditHostDetailMutation,
    useEditHostAgreementFileMutation,
    useEditFranchiseAgreementFileMutation,
    useAddBillingAddressMutation,
    useEditTicketStatusMutation,
    useEditHostChargerMutation,
    useAddContactsMappingMutation,
    usePushToCSMSMutation,
    useUpdateInstallationSequenceMutation,
    useGetEntityMappingStatusQuery,
    useGetPushCSMSLogsQuery,
    useLazyGetPushCSMSLogPayloadQuery,
} = OnboardingService

export { OnboardingService }
